var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiclePax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.633 14.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.618,5.846A1.566,1.566,0,1,1,7.8,5.463,1.573,1.573,0,0,1,5.618,5.846Zm8.324,10.443H8.417A2.338,2.338,0,0,1,6.1,14.3L4.563,6.909H3l1.555,7.629a3.916,3.916,0,0,0,3.869,3.314h5.518Zm.18-3.127H10.308L9.5,9.957a6.048,6.048,0,0,0,4.025.954V9.246a4.763,4.763,0,0,1-3.666-.977L8.581,7.276a1.768,1.768,0,0,0-.594-.3,1.727,1.727,0,0,0-.774-.047H7.2a1.772,1.772,0,0,0-1.438,2.04L6.814,13.6A2.351,2.351,0,0,0,9.12,15.507h5.354l2.986,2.345,1.172-1.172-4.51-3.517Z",
    transform: "translate(-3 -3.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclePax);
export default __webpack_public_path__ + "static/media/VehiclePax.1aa0972b7a9e14afa84cd3ca2edf7433.svg";
export { ForwardRef as ReactComponent };